import React, {useEffect, useState} from 'react';
import {Form, Grid, Header, Segment, Table} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useLocation, useNavigate} from "react-router-dom";
import {ToasterConfig} from "../../../../../../config/ToasterConfig";
import useBonusConfigService from "../../../../../../services/backoffice/hooks/useBonusConfigService";
import {CreateEngineLoadExceptionRequest} from "../../../../../../models/requests/create-engine-load-exception-request";
import useVehiclePlateService from "../../../../../../services/backoffice/hooks/useVehiclePlateService";
import {ShortDto} from "../../../../../../models/short-dto";

const CreateEngineLoadExceptionConfigPage = () => {
    const [bonusConfigException, setBonusConfigException] = useState<Partial<CreateEngineLoadExceptionRequest>>({});
    const [plates, setPlates] = useState<ShortDto[]>([])
    const navigate = useNavigate();
    const {createEngineLoadExceptionBonusConfig} = useBonusConfigService();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const fleetId = params.get('fleetId');
    const tab = params.get('tab');
    const {getAllVehiclePlatesShortDto, getAllVehiclePlatesShortDtoFiltered} = useVehiclePlateService();


    useEffect(() => {
        function ListPlates() {
            getAllVehiclePlatesShortDtoFiltered().then((response) => {
                setPlates(response);
            })
                .catch(error => {
                })
        }

        ListPlates()
    }, [])



    const handleSubmit = async () => {
        try {
            await createEngineLoadExceptionBonusConfig({...bonusConfigException, fleetId: fleetId || ''})
            navigate(`/backoffice/fleets/bonus-configs/?operationId=${fleetId}&tab=${tab}`);
            toast.success('Exceção de carga no motor criada com sucesso', ToasterConfig.success);
        } catch (error) {
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Exceção de carga no motor / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>

                        <Form.Select
                            label={'Placa'}
                            options={plates}
                            placeholder='Selecione uma opção'
                            value={bonusConfigException?.vehiclePlateId || ''}
                            required
                            search
                            clearable
                            onChange={(e: any, data: any) => {
                                const selectedValue = data.value;
                                setBonusConfigException(prevUnit => ({...prevUnit, vehiclePlateId: selectedValue}));
                            }}
                        />


                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate(`/backoffice/fleets/bonus-configs/?operationId=${fleetId}&tab=${tab}`)}
                                             grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             color={"green"}/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateEngineLoadExceptionConfigPage;
